import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// Páginas
import LoginPage from "./pages/login/Login";
import Painel from "./pages/painel/Painel";
import Usuarios from "./pages/usuarios/Usuarios";
import TiposServico from "./pages/tiposservico/TiposServico";
import Clientes from "./pages/clientes/Clientes";
import Agendamentos from "./pages/agendamentos/Agendamentos";
import Relatorio1 from "./pages/Relatorio1";
import Relatorio2 from "./pages/Relatorio2";
import PainelChamados from "./pages/PainelChamados/PainelChamados";
import Produtos from "./pages/produtos/Produtos";
import Whatsapp from "./pages/whatsapp/Whatsapp";
import AtualizacaoSistema from "./pages/AtualizacaoSistema";

// 🔹 Dashboard
import DashBoard from "./components/DashBoard/DashBoard";

// 🔹 Novo Relatório de Chamados
import RelatorioChamado from "./pages/RelatorioChamado/RelatorioChamado";

export default function App() {
  return (
    <>
      {/* 🔔 Notificações */}
      <Toaster position="top-right" reverseOrder={false} />

      <Router>
        <Routes>
          {/* Login */}
          <Route path="/" element={<LoginPage />} />

          {/* Atualização */}
          <Route
            path="/atualizacao"
            element={
              <AtualizacaoSistema
                usuarioId={0}
                apiUrl="http://localhost/backend"
                onFinalizado={() => {
                  window.location.href = "/painel";
                }}
              />
            }
          />

          {/* Painel principal */}
          <Route path="/painel" element={<Painel />}>
            {/* Tela inicial do painel */}
            <Route
              index
              element={
                <div className="text-center mt-12 bg-transparent">
                  <h2 className="text-3xl font-bold text-white mb-2">
                    Bem-vindo ao Painel
                  </h2>
                  <p className="text-white/80 text-lg">
                    Escolha uma opção no menu acima para continuar.
                  </p>
                </div>
              }
            />

            {/* Rotas do Painel */}
            <Route path="dashboard" element={<DashBoard />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="tipos-servico" element={<TiposServico />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="agendamentos" element={<Agendamentos />} />
            <Route path="relatorio1" element={<Relatorio1 />} />
            <Route path="relatorio2" element={<Relatorio2 />} />
            <Route path="painel-chamados" element={<PainelChamados />} />

            {/* 🆕 Nova rota — Relatórios de Chamados */}
            <Route
              path="relatorios-chamados"
              element={<RelatorioChamado />}
            />

            {/* Mantido apenas se precisar futuramente */}
            <Route path="produtos" element={<Produtos />} />
            <Route path="whatsapp" element={<Whatsapp />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}
